function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import ToggledFeature from '@domain-group/fe-allhomes-library/lib/enums/toggled-feature';
import { withAllhomesApi } from '@domain-group/fe-co-allhomes-api-client';
import * as ah from './utils/allhomes';
class AllhomesAnalytics extends React.Component {
  constructor(props) {
    var _this;
    super(props);
    _this = this;
    _defineProperty(this, "queued", void 0);
    _defineProperty(this, "debug", () => {
      var _this$props$toggledFe;
      return (_this$props$toggledFe = this.props.toggledFeatures) === null || _this$props$toggledFe === void 0 ? void 0 : _this$props$toggledFe[ToggledFeature.ANALYTICS_DEBUG.name];
    });
    _defineProperty(this, "flushQueue", () => {
      this.queued.forEach(args => {
        try {
          if (this.props.sendAnalytics) {
            this.props.sendAnalytics(...args);
          }
        } catch (error) {
          if (this.debug()) {
            console.error('Error sending queued event', args);
            console.error(error);
          }
        }
      });
      this.queued = [];
    });
    _defineProperty(this, "sendAnalytics", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (_this.props.sendAnalytics) {
        _this.props.sendAnalytics(...args);
      } else {
        if (_this.debug()) {
          console.log('(legacy) fe-co-allhomes-analytics: queuing event:', ...args);
        }
        _this.queued.push(args);
      }
    });
    this.fireMetric = this.fireMetric.bind(this);
    this.fireListingMetric = this.fireListingMetric.bind(this);
    this.queued = [];
  }
  componentDidUpdate() {
    if (this.debug()) {
      console.log("(legacy) fe-co-allhomes-analytics: componentDidUpdate, event queue contains ".concat(this.queued.length, " items"));
    }
    if (this.props.sendAnalytics && this.queued.length > 0) {
      if (this.debug()) {
        console.log('(legacy) fe-co-allhomes-analytics: flushing event queue');
      }
      this.flushQueue();
    }
  }
  getChildContext() {
    return {
      ahAnalytics: {
        fireMetric: this.fireMetric,
        fireListingMetric: this.fireListingMetric
      }
    };
  }
  componentDidMount() {
    if (this.debug()) {
      console.log('(legacy) fe-co-allhomes-analytics: componentDidMount');
      console.log('(legacy) fe-co-allhomes-analytics: sendAnalytics is', this.props.sendAnalytics);
    }
  }
  fireMetric(metric, additionalData) {
    if (this.props.isEuUser) {
      return;
    }
    if (this.debug()) {
      console.log("(legacy) fe-co-allhomes-analytics: firing metric ".concat(metric).concat(additionalData ? ', additionalData:' : ''), additionalData);
    }
    this.sendAnalytics(ah.metric(metric, additionalData));
  }
  fireListingMetric(listingId, metric, additionalData) {
    if (this.debug()) {
      console.log("(legacy) fe-co-allhomes-analytics: firing listing metric ".concat(metric, ", listingId: ").concat(listingId).concat(additionalData ? ', additionalData:' : ''), additionalData);
    }
    if (this.props.isEuUser) {
      return;
    }
    this.sendAnalytics(ah.listingMetric(listingId, metric, additionalData));
  }
  render() {
    return this.props.children;
  }
}
_defineProperty(AllhomesAnalytics, "defaultProps", {
  isEuUser: false,
  toggledFeatures: {},
  sendAnalytics: undefined
});
_defineProperty(AllhomesAnalytics, "childContextTypes", {
  ahAnalytics: PropTypes.shape({
    fireMetric: PropTypes.func,
    fireListingMetric: PropTypes.func
  })
});
export default withAllhomesApi('sendAnalytics', 'isEuUser', 'toggledFeatures')(AllhomesAnalytics);